const types = {
  FETCH_OPERATOR_DETAILS_START: 'FETCH_OPERATOR_DETAILS_START',
  FETCH_OPERATOR_DETAILS_SUCCESS: 'FETCH_OPERATOR_DETAILS_SUCCESS',
  FETCH_OPERATOR_DETAILS_FAILURE: 'FETCH_OPERATOR_DETAILS_FAILURE',
  INITIATE_OPERATOR_TDS_DECLARATION_START: 'INITIATE_OPERATOR_TDS_DECLARATION_START',
  INITIATE_OPERATOR_TDS_DECLARATION_SUCCESS: 'INITIATE_OPERATOR_TDS_DECLARATION_SUCCESS',
  INITIATE_OPERATOR_TDS_DECLARATION_FAILURE: 'INITIATE_OPERATOR_TDS_DECLARATION_FAILURE',
};

export default types;
